import { Injectable } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { BehaviorSubject } from 'rxjs';
import { MaxBrainTag } from '../models/tag.model';
import { MatSelectChange } from '@angular/material/select';

@Injectable()
export class TagMultiSelectService {
    private _selectedTags = new BehaviorSubject<MaxBrainTag[]>([]);

    selectedTag$ = this._selectedTags.asObservable();

    get selectedTags(): MaxBrainTag[] {
        return this._selectedTags.value;
    }

    tagCtrl = new FormControl([]);

    constructor() {
        // Ensure `tagCtrl` is always in sync with selected tags
        this.selectedTag$.subscribe((tags) => {
            this.tagCtrl.setValue(tags, { emitEvent: false });
        });
    }

    setFromStorage(storageKey: string): void {
        const tags: MaxBrainTag[] = JSON.parse(sessionStorage.getItem(storageKey)) || [];
        this._selectedTags.next(tags);
    }

    resetTags(): void {
        this._selectedTags.next([]);
    }

    trackById(index: number, item: MaxBrainTag): string {
        return item.id;
    }

    compareTags(tag1: MaxBrainTag, tag2: MaxBrainTag): boolean {
        return tag1?.id === tag2?.id;
    }

    removeTag(tagToRemove: MaxBrainTag, storageKey: string): void {
        const updatedTags = this.selectedTags.filter((tag) => tag.id !== tagToRemove.id);
        this._selectedTags.next(updatedTags);
        this.tagCtrl.setValue(updatedTags, { emitEvent: false });

        if (storageKey) {
            sessionStorage.setItem(storageKey, JSON.stringify(updatedTags));
        }
    }

    tagSelected(event: MatAutocompleteSelectedEvent | MatSelectChange, storageKey: string): void {
        let newTags: MaxBrainTag[] = [];

        if (event instanceof MatAutocompleteSelectedEvent) {
            newTags = [...this.selectedTags, event.option ? event.option.value : event];
        } else if (event instanceof MatSelectChange) {
            newTags = [...this.selectedTags, ...event.value];
        } else {
            newTags = [...this.selectedTags, event];
        }

        // Toggle selection: Remove if already selected, otherwise add
        const updatedTags = [...this.selectedTags];
        newTags.forEach((tag) => {
            const index = updatedTags.findIndex((t) => t.id === tag.id);
            if (index !== -1) {
                updatedTags.splice(index, 1); // Remove if exists
            } else {
                updatedTags.push(tag); // Add if not exists
            }
        });

        this._selectedTags.next(updatedTags);
        this.tagCtrl.setValue(updatedTags, { emitEvent: false });

        if (storageKey) {
            sessionStorage.setItem(storageKey, JSON.stringify(updatedTags));
        }
    }
}
